// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__CnuwS","dragIcon":"Choice_dragIcon__2o8Ek","left":"Choice_left__3gOLF","input":"Choice_input__YoKgk"};